import { InMemoryCache } from '@apollo/client/core'

const cache = new InMemoryCache()

export default cache